// extracted by mini-css-extract-plugin
module.exports = {"claimCompanyHeader":"styles_claimCompanyHeader__KW9Og","claimNowText":"styles_claimNowText__yscU_","logo":"styles_logo__2gFK5","claimButton":"styles_claimButton__2fua-"};